import { createActionGroup, createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { zefActionPayload, zefActionSuccessPayload, zefActionFailPayload } from '@zerops/zef/core';
import { ClientUser, ClientUserAddPayload, UserProjectRolesPayload, UserProjectRolesResponse, UserProjectRole } from '@zerops/models/client-user';
import { FEATURE_NAME } from './client-user-base.constant';

// # Actions
export const clientUserActions = createActionGroup({
  source: FEATURE_NAME,
  events: {
    'Create User': zefActionPayload<{
      clientId: string;
      payload: Omit<ClientUserAddPayload, 'clientId'>;
    }>(),
    'Create User Success': zefActionSuccessPayload<{ response: ClientUser }>(),
    'Create User Fail': zefActionFailPayload,
    'Load Project Roles': zefActionPayload<{ userId: string }>(),
    'Load Project Roles Success': zefActionSuccessPayload<{
      userId: string;
      response: UserProjectRolesResponse
    }>(),
    'Load Project Roles Fail': zefActionFailPayload,
    'Update Project Roles': zefActionPayload<{
      userId: string;
      payload: UserProjectRolesPayload;
    }>(),
    'Update Project Roles Success': zefActionSuccessPayload<{
      userId: string;
      response: UserProjectRolesResponse
    }>(),
    'Update Project Roles Fail': zefActionFailPayload
  }
});

// # State
export interface ClientUserBaseState {
  projectRolesByUserId: Record<string, UserProjectRole[]>;
}

const initialState: ClientUserBaseState = {
  projectRolesByUserId: {}
};

// # Reducer
export const clientUserBaseFeature = createFeature({
  name: FEATURE_NAME,
  reducer: createReducer(
    initialState,
    on(
      clientUserActions.loadProjectRolesSuccess,
      clientUserActions.updateProjectRolesSuccess,
      (state, { data }) => ({
        ...state,
        projectRolesByUserId: {
          ...state.projectRolesByUserId,
          [data.userId]: data.response.projectRoleList
        }
      })
    )
  )
});

// # Selectors
export const {
  name: clientUserBaseFeatureKey,
  reducer: clientUserBaseReducer,
  selectProjectRolesByUserId
} = clientUserBaseFeature;

export const selectProjectRolesByUser = (userId: string) => createSelector(
  selectProjectRolesByUserId,
  (rolesMap) => rolesMap[userId] || []
);
